module.exports = __webpack_public_path__ + "img/Malaysia-4-hover.c582445d.jpg";